import { useState, useEffect } from "react";
import { XIcon } from "@heroicons/react/solid";

const BankAvailabilityModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  initialData = {
    bankCode: "",
    bankName: "",
    status: "Available",
    reason: "",
  },
  loading = false,
  isEditMode = false,
}) => {
  const [formData, setFormData] = useState(initialData);
  const [error, setError] = useState("");

 useEffect(() => {
  if (isOpen) {
    setFormData(initialData);
    setError("");
  }
}, [isOpen, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.reason.trim() && isEditMode) {
      setError("Reason is required for updates");
      return;
    }
    setError("");
    onSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-xl font-medium text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-red-500 hover:text-gray-500"
            disabled={loading}
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-4">
          {error && (
            <div className="mb-4 p-4 bg-red-100 text-red-700 rounded flex items-center">
              <XIcon className="h-5 w-5 mr-2" />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="bankCode">
                Bank Code
              </label>
              <input
                type="text"
                id="bankCode"
                name="bankCode"
                value={formData.bankCode}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                // Remove the disabled prop to allow editing
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="bankName">
                Bank Name
              </label>
              <input
                type="text"
                id="bankName"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                // Remove the disabled prop to allow editing
              />
            </div>

            {!isEditMode && (
              <div className="mb-4">
                <label className="block text-gray-700 mb-2" htmlFor="status">
                  Status
                </label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Available">Available</option>
                  <option value="NotAvailable">Not Available</option>
                </select>
              </div>
            )}

            <div className="mb-6">
              <label className="block text-gray-700 mb-2" htmlFor="reason">
                Reason {isEditMode && "(Required)"}
              </label>
              <textarea
                id="reason"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={isEditMode}
              />
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="mr-3 px-4 py-2 border border-red-300 rounded-md text-red-700 hover:bg-red-500 disabled:opacity-50 hover:text-white"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50"
              >
                {loading
                  ? isEditMode
                    ? "Updating..."
                    : "Creating..."
                  : isEditMode
                  ? "Update"
                  : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BankAvailabilityModal;
